class Footer {
  constructor() {
    this.copyrightElement = document.querySelector('.site-footer #copyright');

    if (this.copyrightElement) {
      let copy = new Date().getFullYear();
      this.copyrightElement.insertAdjacentText('beforeend', copy);
    }
  }
}

export default Footer;
